module.exports = __webpack_public_path__ + "img/contact_customer.0425ee39.png";